import { xor } from 'lodash-es'
import {
  Checkbox,
  IconButton,
  LocalIcon,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/shared/ui'
import { MAX_VISIBLE_COLUMNS_COUNT, TABLE_COLUMNS_MAP } from '../../config'
import { useTableSettings } from '../../model'

export function Settings() {
  const { hiddenColumns, setHiddenColumns } = useTableSettings()

  const toggleColumnVisibility = (column: keyof typeof TABLE_COLUMNS_MAP) => {
    setHiddenColumns(xor(hiddenColumns, [column]))
  }

  const columns = Object.entries(TABLE_COLUMNS_MAP).filter(([_, value]) => value.canBeHidden)

  return (
    <Popover>
      <PopoverTrigger asChild>
        <IconButton
          size="medium"
          container="medium"
        >
          <LocalIcon name="settingsOutlined" />
        </IconButton>
      </PopoverTrigger>
      <PopoverContent align="end">
        <div className="border-divider flex flex-col border-t py-1 pr-4 pl-1.5">
          {columns.map(([key, value]) => (
            <Checkbox
              key={key}
              label={value.label}
              checked={!hiddenColumns.includes(key as keyof typeof TABLE_COLUMNS_MAP)}
              onChange={() => toggleColumnVisibility(key as keyof typeof TABLE_COLUMNS_MAP)}
              disabled={
                columns.length - hiddenColumns.length >= MAX_VISIBLE_COLUMNS_COUNT &&
                hiddenColumns.includes(key as keyof typeof TABLE_COLUMNS_MAP)
              }
            />
          ))}
        </div>
      </PopoverContent>
    </Popover>
  )
}
